import { render, staticRenderFns } from "./single.vue?vue&type=template&id=f57ce5ac&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=f57ce5ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57ce5ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f57ce5ac')) {
      api.createRecord('f57ce5ac', component.options)
    } else {
      api.reload('f57ce5ac', component.options)
    }
    module.hot.accept("./single.vue?vue&type=template&id=f57ce5ac&scoped=true&", function () {
      api.rerender('f57ce5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/case_opening/single.vue"
export default component.exports